@if (showAoUpsell) {
    <div class="form-check form-check-wrapper ao-upsell-container">
        <label class="form-check-label plain-slim">
            <input type="checkbox" class="form-check-input" name="createAoUpsell" [(ngModel)]="createAoUpsell"
                   [ngModelOptions]="{standalone: true}" (change)="onSubscribeCheckboxChange()">
            <span translate="cart.checkout.ao.subscribe.save.label" class="ao-upsell-label"></span>
        </label>
        <div class="margin-left-24">
            @if (createAoUpsell && shippingCycleTypes?.length) {
                <label class="margin-top-4">
                    @if (!!selectedShippingCycleTypeMsg) {
                        <span [innerHTML]="selectedShippingCycleTypeMsg"></span>
                    }
                    @if (!isEditingCycle) {
                        <a class="d-block" (click)="isEditingCycle = true" translate="cart.checkout.ao.change.cycle.type"
                           [attr.data-testid]="'cart.checkout.ao.change.cycle.type'"></a>
                    }
                    @if (isEditingCycle) {
                        <select [(ngModel)]="selectedShippingCycleType"
                                name="cart.field.ShippingCycleType.id" (change)="onShippingCycleTypeChange()" class="form-select">
                            @for (shippingCycleType of shippingCycleTypes; track trackByFn) {
                                <option [ngValue]="shippingCycleType">{{ shippingCycleType.description }}</option>
                            }
                        </select>
                    }
                </label>
            }
            @if (createAoUpsell && aoUpsellSubtotal > 0 && !hideEstimatedSaveMessage) {
                <div class="save-estimate">
                    <span translate="cart.checkout.ao.subscribe.save.estimated"></span><span class="fw-bold"> {{aoUpsellSubtotal | usanacurrency | async}}</span>
                </div>
            }
            @if (createAoUpsell && totalIoReward > 0) {
                <div class="save-estimate ior-message">
                    <i class="fa-solid fa-sparkles margin-right-8"></i>
                    <span translate="cart.checkout.ao.ior.save"></span><span class="fw-bold"> {{(totalIoReward) | usanacurrency | async}}</span>
                </div>
            }
        </div>
    </div>
    <div class="save-description">*<span translate="cart.checkout.ao.subscribe.save.desc"></span></div>
}
